import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { InvitationEmailStatus } from './invitation-email-status.model';
import { UserInvitationSource } from './user-invitation-source.model';

/**
 * One of a user's invitations from GET /admin/users/:id/invitations (hub `admin-users-controller.ts`), which
 * merges profile and organization invitations, per `ADMIN_USER_INVITATION_READABLE`. Profile invitations
 * carry `type`; organization invitations carry `role`.
 */
export class UserInvitation extends Base {
  source: UserInvitationSource;
  email?: string | null;
  /** `pending` | `accepted` | `cancelled` | `expired`, computed by the hub. */
  status?: string | null;
  type?: string | null;
  role?: number | null;
  /** ISO timestamp as sent by the hub. */
  expiresAt?: string | null;
  emailStatus?: InvitationEmailStatus | null;
  resendCount: number;
  organizationName?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.source = source['source'] === 'organization' ? 'organization' : 'profile';
    this.email = nullableString(source['email']);
    this.status = nullableString(source['status']);
    this.type = nullableString(source['type']);
    this.role = nullableNumber(source['role']);
    this.expiresAt = nullableString(source['expiresAt']);
    this.emailStatus = nullableString(source['emailStatus']) as InvitationEmailStatus | null | undefined;
    this.resendCount = countOrZero(source['resendCount']);
    this.organizationName = nullableString(source['organizationName']);
  }
}
